import OperationalReportPage from './OperationalReportPage';
export default function OnlineFulfilmentReportPage(){return <OperationalReportPage kind="online-fulfilment"/>;}
